/* Tervi – Cart drawer: svensk översättning + styling.
   Scopat ENBART till cart drawern (cart-drawer / #CartDrawer).
   Laddas via en rad i layout/theme.liquid. MutationObserver håller
   översättningen intakt när drawern re-renderas via cart-API:t. */
(function () {
  'use strict';

  var BTN_COLOR = '#121F2E'; /* TILL KASSAN-knappen */
  var BAR_COLOR = '#0A2534'; /* Gratis frakt-baren (ersätter orange) */

  /* ---------- 1. Injicerad CSS: färger + dölj login-text ---------- */
  function injectStyles() {
    if (document.getElementById('tervi-drawer-sv-style')) return;
    var css = '' +
      '#CartDrawer{--cart-drawer-checkout-button-background:' + BTN_COLOR + ';' +
      '--cart-drawer-progress-active-color:' + BAR_COLOR + ';}' +
      '.cart-drawer .cart__checkout-button{background-color:' + BTN_COLOR + ' !important;border-color:' + BTN_COLOR + ' !important;}' +
      '.cart-drawer .free-product-progress-bar progress{color:' + BAR_COLOR + ' !important;}' +
      '.cart-drawer .free-product-progress-bar progress::-webkit-progress-value{background-color:' + BAR_COLOR + ' !important;background-image:none !important;}' +
      '.cart-drawer .free-product-progress-bar progress::-moz-progress-bar{background-color:' + BAR_COLOR + ' !important;background-image:none !important;}' +
      '.cart-drawer .cart__login-title,.cart-drawer .cart__login-paragraph,.cart-drawer .cart__login-link,' +
      '.drawer__inner-empty .cart__login-title,.drawer__inner-empty .cart__login-paragraph,.drawer__inner-empty .cart__login-link{display:none !important;}';
    var tag = document.createElement('style');
    tag.id = 'tervi-drawer-sv-style';
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  /* ---------- 2. Ordbok (längsta fraser först) ---------- */
  var MAP = [
    [/You(?:'|\u2019)?ve earned free shipping!?/gi, 'Du har fått gratis frakt'],
    [/Shipping,? taxes,? and discount codes? calculated at checkout\.?/gi, 'Frakt, skatt och rabattkoder beräknas i kassan'],
    [/Taxes? and shipping calculated at checkout\.?/gi, 'Skatt och frakt beräknas i kassan'],
    [/Your cart is currently empty\.?/gi, 'Din varukorg är tom'],
    [/Your cart is empty\.?/gi, 'Din varukorg är tom'],
    [/Continue shopping/gi, 'Fortsätt handla'],
    [/Secure checkout/gi, 'TILL KASSAN'],
    [/Proceed to checkout/gi, 'TILL KASSAN'],
    [/\bCheck ?out\b/g, 'TILL KASSAN'],
    [/\bcheckout\b/g, 'kassan'],
    [/Free shipping/gi, 'Gratis frakt'],
    [/Your Cart/g, 'Din Varukorg'],
    [/Your cart/g, 'Din varukorg'],
    [/\bSavings\b/gi, 'Du sparar'],
    [/\bSubtotal\b/gi, 'Delsumma'],
    [/Estimated total/gi, 'Beräknat totalbelopp'],
    [/\bTotal\b/g, 'Totalt'],
    [/\bQuantity\b/gi, 'Antal'],
    [/\bQty\b/gi, 'Antal'],
    [/\bRemove\b/g, 'Ta bort'],
    [/Discount codes?/gi, 'Rabattkod'],
    [/\bDiscounts\b/g, 'Rabatter'],
    [/\bDiscount\b/g, 'Rabatt'],
    [/\bSave\b/g, 'SPARA'],
    [/Add to cart/gi, 'Lägg i varukorgen'],
    [/View cart/gi, 'Visa varukorg'],
    [/Free gift/gi, 'Gratis gåva'],
    [/\bFree\b/g, 'Gratis'],
    [/\bItems\b/g, 'varor'],
    [/\bItem\b/g, 'vara'],
    [/\bto unlock\b/gi, 'för att låsa upp'],
    [/\bmore to get\b/gi, 'till för att få'],
    [/\baway from\b/gi, 'kvar till'],
    [/\bSpend\b/g, 'Handla för'],
    [/\beach\b/g, 'per st']
  ];

  function translateString(s) {
    for (var i = 0; i < MAP.length; i++) s = s.replace(MAP[i][0], MAP[i][1]);
    return s;
  }

  /* ---------- 3. Ta bort login-texten i tom varukorg helt ---------- */
  function removeLoginPrompt(root) {
    root.querySelectorAll('.cart__login-title, .cart__login-paragraph, .cart__login-link').forEach(function (el) {
      el.remove();
    });
    root.querySelectorAll('p, a, h2, h3, span, div').forEach(function (el) {
      if (el.children.length > 1) return;
      var t = (el.textContent || '').trim();
      if (/Have an account|check out faster/i.test(t) && t.length < 80) el.remove();
    });
  }

  function translateTextNodes(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        var tag = p.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') return NodeFilter.FILTER_REJECT;
        return /\S/.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var node;
    while ((node = walker.nextNode())) {
      var next = translateString(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
  }

  function translateAttributes(root) {
    var els = root.querySelectorAll('[aria-label], [placeholder], [title], input[type="submit"], input[type="button"]');
    els.forEach(function (el) {
      ['aria-label', 'placeholder', 'title', 'value'].forEach(function (attr) {
        if (attr === 'value' && el.tagName !== 'INPUT') return;
        var v = el.getAttribute(attr);
        if (!v) return;
        var next = translateString(v);
        if (next !== v) el.setAttribute(attr, next);
      });
    });
  }

  /* ---------- 4. Prisstorlek: +1 (huvudsektion + footer) ---------- */
  function bumpPrices(root) {
    var sel = '.totals__total-value, .cart-item__final-price, .gb-price-drawer, .gb-price-drawer strong, .cart-item__price-wrapper .price';
    root.querySelectorAll(sel).forEach(function (el) {
      if (el.dataset.terviBumped) return;
      var size = parseFloat(window.getComputedStyle(el).fontSize);
      if (size) {
        el.style.setProperty('font-size', (size + 1) + 'px', 'important');
        el.dataset.terviBumped = '1';
      }
    });
  }

  /* ---------- 5. Fånga ev. orange bakgrund på frakt-baren ---------- */
  function fixBarBackground(root) {
    var els = root.querySelectorAll('.free-product-progress-bar-main, .free-product-progress-bar-main *');
    els.forEach(function (el) {
      var cs = window.getComputedStyle(el);
      var sources = [cs.backgroundColor || '', cs.backgroundImage || ''];
      var isOrange = sources.some(function (s) {
        var m = s.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
        if (m) {
          var r = +m[1], g = +m[2], b = +m[3];
          return r > 180 && g > 60 && g < 200 && b < 120 && r > b + 70;
        }
        return /#ff5801|255,\s*88,\s*1/i.test(s);
      });
      if (isOrange) {
        el.style.setProperty('background-color', BAR_COLOR, 'important');
        el.style.setProperty('background-image', 'none', 'important');
      }
    });
  }

  /* ---------- Kör allt, scopat till drawern ---------- */
  function getDrawerRoots() {
    var roots = [];
    document.querySelectorAll('cart-drawer, #CartDrawer').forEach(function (el) {
      if (!roots.some(function (r) { return r.contains(el); })) roots.push(el);
    });
    return roots;
  }

  var scheduled = false;
  function apply() {
    scheduled = false;
    var roots = getDrawerRoots();
    if (!roots.length) return;
    injectStyles();
    roots.forEach(function (root) {
      removeLoginPrompt(root);
      translateTextNodes(root);
      translateAttributes(root);
      bumpPrices(root);
      fixBarBackground(root);
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(apply);
  }

  function init() {
    apply();
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        var el = t.nodeType === 1 ? t : t.parentElement;
        if (el && el.closest && el.closest('cart-drawer, #CartDrawer, .cart-drawer')) {
          schedule();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
